import * as React from 'react'
import cx from 'classnames'
import styles from './SubmissionSection.sass'

interface SubmissionSectionProps {
  children?: React.ReactNode
  compact?: boolean
}

/**
 " Submission Section
 */
export function SubmissionSection({
  children,
  compact,
}: SubmissionSectionProps) {
  return (
    <div className={cx(styles.root, compact && styles.compact)}>{children}</div>
  )
}

interface SubmissionSectionHeaderProps {
  label: React.ReactNode
  children?: React.ReactNode
  compact?: boolean
}

/**
 " Section Header
 */
export function SubmissionSectionHeader({
  label,
  children,
  compact,
}: SubmissionSectionHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={cx(styles.label, compact && styles.compact)}>{label}</div>
      <div className={styles.action}>{children}</div>
    </div>
  )
}

interface SubmissionSectionContentProps {
  children?: React.ReactNode
}

/**
 " Submission Section Content
 */
export function SubmissionSectionContent({
  children,
}: SubmissionSectionContentProps) {
  return <div className={styles.content}>{children}</div>
}
